import { Action } from '@ngrx/store';
import { YourDependantDetails } from '../../model/ngrx/your-dependant-details.model';
import * as YourDependantDetailsActions from './../actions/your-dependant-details.actions';

export type Actions = YourDependantDetailsActions.Actions;

export function YourDependantDetailsReducer(state: YourDependantDetails[] = [], action: YourDependantDetailsActions.Actions) {
    switch (action.type) {
        case YourDependantDetailsActions.ADD_YOUR_DEPENDANT_DETAILS:
            return [...state, action.payload];

        // Add this case:
        case YourDependantDetailsActions.REMOVE_YOUR_DEPENDANT_DETAILS:
            state = [];
            return state;

        default:
            return state;
    }
}
